import React from "react";
import { useTranslation } from "react-i18next";
import { FormInputControl, DropDownBs, DatePickers } from "../common";

function FormsControl(props) {
  console.log(props, "props in form control", props.status);
  const { t } = useTranslation();

  const inputContainerStyle = {
    display: "inline-block",
    margin: "0 10px",
    verticalAlign: "middle",
    width: "33.33%",
    // whiteSpace:props.data.code=="accountType"?"nowrap":"",
  };

  const inputStyle = {
    display: "inline-block",
    margin: "0",
    minWidth: "0",
    width: "300px",
    // whiteSpace:"nowrap"
  };

  const Components = (type) => {
    if (
      type === "text" ||
      type === "email" ||
      type === "textarea" ||
      type === "number" ||
      type === "password" ||
      type === "select"
    ) {
      // const isDisabled =
      //   (props.uploadedData &&
      //     (props.data.code === "firstName" ||
      //       props.data.code === "lastName" ||
      //       props.data.code === "middleName" ||
      //       props.data.code === "gender" ||
      //       props.data.code === "placeOfBirth" ||
      //       props.data.code === "relationship" ||
      //       props.data.code === "beneficiary")) ||
      //   !props.uploadedData;
      const isDisabled =
        (props.uploadedData &&
          (props.data.code === "firstName" ||
            props.data.code === "lastName" ||
            props.data.code === "middleName" ||
            props.data.code === "gender" ||
            props.data.code === "placeOfBirth" ||
            props.data.code === "relationship" ||
            props.data.code === "beneficiary" ||
            props.data.code == "dateOfBirth" ||
            props.data.code == "mothersName" ||
            props.data.code == "gender")) ||
        (!props.uploadedData && props.data.code !== "accountNo");
      if (type === "select") {
        console.log("Dropdown value:", props.data.value);
        console.log("Options:", props.data.options);
        return (
          // <div style={{ width: "33.33%", display: "inline-block" }}>
          //   <div style={inputContainerStyle}>
          //     <DropDownBs
          //       label={t("profile." + props.data.code)}
          //       required={props.data.required}
          //       // preOption={props.data.code}
          //       preOption={t("Common." + props.data.code)}
          //       options={{
          //         data: props.data.options || [],
          //         value: "value",
          //         label: "title",
          //       }}
          //       status={props?.extraDetails?.bankStatus}
          //       DropdownProps={{
          //         disabled: props.status,
          //         onChange: (e) => {
          //           props.dropdownChange(e.target.value, props.data);
          //         },
          //         // value: props.data.value ?? "",
          //         value:
          //           props.data.value !== null
          //             ? props.data.code === "currency"
          //               ? parseInt(props.data.value)
          //               : props.data.value
          //             : "",
          //         style: inputStyle,
          //       }}
          //       extraDetails={props?.extraDetails}
          //     />
          //   </div>
          // </div>
          <div style={{ width: "33.33%", display: "inline-block" }}>
            <div style={inputContainerStyle}>
              <DropDownBs
                label={t("profile." + props.data.code)}
                required={props.data.required}
                preOption={t("Common." + props.data.code)}
                options={{
                  data: props.data.options || [],
                  value: "value",
                  label: "title",
                }}
                status={props?.extraDetails?.bankStatus}
                DropdownProps={{
                  disabled: props.status,
                  onChange: (e) => {
                    props.dropdownChange(e.target.value, props.data);
                  },
                  value: props.data.value !== null ? props.data.value : "",
                  style: inputStyle,
                }}
                extraDetails={props?.extraDetails}
              />
            </div>
          </div>
        );
      } else if (type === "date") {
        return (
          <div style={{ width: "33.33%", display: "inline-block" }}>
            <div style={inputContainerStyle}>
              {/* {props.data.field === "bankName" && (
                <span style={{ fontSize:"12px", fontWeight: "bold" }}>Status: Active</span>
              )} */}
              <DatePickers
                disabled={props.status || isDisabled}
                start={props.data.value}
                datechange={props.dateChange}
                id={props.data.code}
                label={t("profile." + props.data.code)}
                error={{
                  error: props.data.error,
                  field: props.data.errorField,
                }}
                style={inputStyle}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div style={{ width: "33.33%", display: "inline-block" }}>
            <div style={inputContainerStyle}>
              {/* <div
              style={
                props?.data?.code === "bankName"
                  ? { display: "flex", justifyContent: "space-between" }
                  : inputContainerStyle
              }
            > */}
              {props?.data?.code == "bankName" &&
                props?.extraDetails?.bankStatus != "" && (
                  <span
                    style={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      marginLeft: "1em",
                    }}
                  >
                    Status:
                    {props?.extraDetails?.bankStatus}
                  </span>
                )}
              <FormInputControl
                status={props?.extraDetails?.bankStatus}
                label={
                  props.data.custom
                    ? props.data.code
                    : t("profile." + props.data.code)
                }
                required={props.data.required}
                inputProps={{
                  id: props.data.code,
                  name: props.data.code,
                  type: type,
                  value: props.data.value ?? "",
                  disabled: props.status || isDisabled,
                  // disabled:isDisabled,
                  onChange: (e) => props.change(e, props.data.required),
                  style: inputStyle,
                }}
                error={{
                  error: props.data.error,
                  field: props.data.errorField,
                }}
              />
            </div>
          </div>
        );
      }
    } else if (type === "select") {
      console.log("form control data inside select", props.data.code);
      const isDisabled =
        (props.uploadedData &&
          (props.data.code === "firstName" ||
            props.data.code === "lastName" ||
            props.data.code === "middleName" ||
            props.data.code === "gender" ||
            props.data.code === "placeOfBirth" ||
            props.data.code === "relationship" ||
            props.data.code === "beneficiary" ||
            props.data.code == "gender")) ||
        // props.data.code === "country"||
        // props.data.code === "province"||
        // props.data.code === "city"||
        // props.data.code === "barangay"
        (!props.uploadedData && props.data.code !== "accountNo");
      return (
        <div style={{ width: "33.33%", display: "inline-block" }}>
          <div style={inputContainerStyle}>
            <DropDownBs
              label={t("profile." + props.data.code)}
              required={props.data.required}
              preOption={props.data.code}
              options={{
                data: props.data.options || [],
                value: "value",
                label: "title",
              }}
              status={props?.extraDetails?.bankStatus}
              DropdownProps={{
                disabled: props.status,
                onChange: (e) => {
                  props.dropdownChange(e.target.value, props.data);
                },
                value: props.data.value ?? "",
                style: inputStyle,
              }}
              extraDetails={props?.extraDetails}
            />
          </div>
        </div>
      );
    } else if (type === "date") {
      return (
        <div style={{ width: "33.33%", display: "inline-block" }}>
          <div style={inputContainerStyle}>
            {/* {props.data.field === "bankName" && (
              <span style={{ fontSize:"12px", fontWeight: "bold" }}>Status: Active</span>
            )} */}
            <DatePickers
              disabled={props.status}
              start={props.data.value}
              datechange={props.dateChange}
              id={props.data.code}
              label={t("profile." + props.data.code)}
              error={{
                error: props.data.error,
                field: props.data.errorField,
              }}
              style={inputStyle}
            />
          </div>
        </div>
      );
    }
  };

  return Components(props.data.type);
}

export default FormsControl;
